import ShowDialogServiceConstants from "./DialogServiceConstants.js";
const getDefaultState = () => {
  return {
    showDialogWith: null
  };
};
const showDialog = (state, actionResult) => {
  const showDialogWith = actionResult.payload;
  return {
    showDialogWith
  };
};
const closeDialog = (state, actionResult) => {
  return {
    showDialogWith: null
  };
};
const AnalysisStudyListReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case ShowDialogServiceConstants.SHOW_DIALOG:
      return showDialog(state, actionResult);
    case ShowDialogServiceConstants.CLOSE_DIALOG:
      return closeDialog(state, actionResult);
    default:
      return state;
  }
};
export {
  AnalysisStudyListReducer,
  AnalysisStudyListReducer as default,
  getDefaultState
};
//# sourceMappingURL=DialogServiceReducer.js.map
